import React, { Component } from "react";
import { IconContext } from "react-icons";
import { FaTimes } from "react-icons/fa";
import { Link } from "gatsby";
import Application from "./Application/index.jsx";
import styles from "./style.module.scss";

class Apply extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false
    };
  }

  componentWillMount() {
    this.resetComponent();
  }

  resetComponent = () =>
    this.setState({
      hover: false,
      submitted: false
    });

  onSubmit = () => {
    this.setState({ submitted: true });
  };

  handleMouseEnter = () => {
    this.setState({ hover: true });
  };

  handleMouseLeave = () => {
    this.setState({ hover: false });
  };

  handleClick = () => {
    this.refs.body.scrollIntoView({ behavior: "smooth" });
  };

  render() {
    const { hover, submitted } = this.state;

    const RenderApplication = () => (
      <div className={styles.form}>
        <Application onSubmit={this.onSubmit} />
      </div>
    );

    const SubmitMessage = () => (
      <h3 className={styles.submitMessage}>
        Congrats! You're one step closer to becoming a Greek Dressing Campus
        Manager. We will be in touch with you shortly!
      </h3>
    );

    return (
      <div className={styles.container}>
        <Link to="/campus-managers" className={styles.link}>
          <IconContext.Provider
            value={{ size: "2em", className: styles.toggle }}
          >
            <FaTimes />
          </IconContext.Provider>
        </Link>
        <div className={styles.content}>
          <div className={styles.heading}>
            <span>
              we’re looking for
              <span className={styles.bold}>college students </span>
              who have what it takes to grow their
              <span className={styles.bold}> own business</span>.
            </span>
            <h3 onClick={this.handleClick}>
              <i></i>
            </h3>
          </div>
          <div className={styles.body} ref="body">
            <div className={styles.description}>
              <h2>About Greek Dressing</h2>
              <p>
                Get ready, we’re coming for ya. Greek Dressing is at the
                intersection of creating the hottest college apparel and an
                unparalleled customization experience, delivering dope shi(r)t
                to campuses nationwide. Our team of talented Campus Managers and
                Graphic Designers work directly with customers at their
                University, allowing for a completely individualized apparel
                ordering experience like never before. We’ve heard the rumor,
                and it’s true: Organizations love to{" "}
                <strong>#GetDressed</strong> by the best.
              </p>
            </div>
            <div className={styles.description}>
              <h2>What's it like to be a campus manager?</h2>
              <p>
                Work hard, play hard is the best way to describe it. Campus
                managers are the “go to” person for clients at their school.
                Given the busy schedules of college students, campus managers
                have the advantage of “making their own hours”. Did someone say
                beer fund?
              </p>
            </div>
            <div className={styles.description}>
              <h2>You</h2>
              <p>
                You’re a go-getter who loves a challenge. We’re looking for
                individuals who thrive in social settings and are ready to make
                (money) moves on their campus. Whether this is your first gig or
                you're a serial entrepreneur, all you need is motivation and
                dedication to get started. Think you have what it takes to be a
                killer campus manager? Apply now to join the team.
              </p>
            </div>
          </div>
        </div>
        <div className={styles.form} ref="application">
          {submitted ? <SubmitMessage /> : <RenderApplication />}
        </div>
      </div>
    );
  }
}

export default Apply;
